import Vue from 'vue'
import Vuex from 'vuex'
const CACHE_KEY = 'CACHED.AUTH'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    userRoles: ''
  },
  getters: {
    // 判断当前用户是否有某个角色
    hasRole: state => role => {
      if (!role) return true // 没有角色，放行
      let roles = state.userRoles || (localStorage.getItem(CACHE_KEY) && localStorage.getItem(CACHE_KEY).userRoles) || ''
      // 单个角色
      if (typeof role === 'string') {
        return roles.indexOf(role) > -1
      } else {
        return role.some(v => roles.indexOf(v) > -1)
      }
    }
  },
  mutations: {

  },
  actions: {
    hasRole ({ state, commit }, role) {

    }
  }
})
